import { takeEvery, put, call } from "redux-saga/effects";
import { showToast } from '../../components/Toast';
// import io from 'socket.io-client';
import { 
  /* PRICE LIST */
  GET_PRICES_DATA, 
  ADD_PRICE_PRODUCT,
  UPDATE_PRICE_PRODUCT, 
  DELETE_PRICE_PRODUCT,
  UPDATE_RESP_REGION, 
  CLEAR_FONT, 
  GET_FONT,
  /* PRICE INFO */
  GET_INFO_DATA,
  ADD_INFO_DATA,
  UPDATE_INFO_DATA,
  DELETE_INFO_DATA,



  // GET_CAT_PRODUCTS_DATA,
  // GET_ACCESS_DATA, 
  // GET_PRODUCTS_DATA, 
  // GET_REG_PRODUCTS_DATA, 
  // GET_REGION_INFO, 
  // ADD_DATA_REGION 
} from './actionTypes';

import {
  /* PRICE LIST */
  getPricesDataSuccess, getPricesDataFail,
  addPriceProductSuccess, addPriceProductFail, 
  updatePriceProductSuccess, updatePriceProductFail, 
  deletePriceProductSuccess, deletePriceProductFail, 
  updateRespRegionSuccess, updateRespRegionFail,
  clearFontSuccess, getFontSuccess, getFontFail,
  /* PRICE INFO */
  getInfoDataSuccess, getInfoDataFail,
  addInfoDataSuccess, addInfoDataFail,
  updateInfoDataSuccess, updateInfoDataFail,
  deleteInfoDataSuccess, deleteInfoDataFail,

  showLoading, hideLoading,



  // getCatProductsDataSuccess, getCatProductsDataFail,
  // getAccessDataSuccess, getAccessDataFail,
  // getProductsDataSuccess, getProductsDataFail,
  // getRegProductsDataSuccess, getRegProductsDataFail, 
  // getRegionInfoSuccess, getRegionInfoFail,  
  } from './actions';

import { 
  /* PRICE LIST */
  getPricesInfo, addPriceProduct, updatePriceProduct, deletePriceProduct, updateResponsibleRegion, getFont,
  /* PRICE INFO */
  addInfoData, updateInfoData, deleteInfoData
  // getInfo,
  // getCatProductsInfo, getAccessInfo, getProductsInfo, getRegProductsInfo, 
  // , getRegionInfo, , , 
  // addProductsRegion 
} from "../../helpers/backend_helper";


function* onGetPricesInfo() {
  try {
    yield put(showLoading(true))
    const response = yield call(getPricesInfo)
    yield put(getPricesDataSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(getPricesDataFail(error))
  }
}

function* onAddPriceProduct({ payload: data }) {
  try {
    yield put(showLoading(true))
    const response = yield call(addPriceProduct, data)
    showToast("New Product is added")
    yield put(addPriceProductSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(addPriceProductFail(error.response))
  }
}

function* onUpdatePriceProduct({ payload: product }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updatePriceProduct, product)
    showToast("Changes Successfully Applied")
    yield put(updatePriceProductSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updatePriceProductFail(error))
  }
}

function* onDeletePriceProduct({ payload: product }) {
  try {
    yield put(showLoading(true))
    const response = yield call(deletePriceProduct, product)
    showToast("Product is deleted from the system")
    yield put(deletePriceProductSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(deletePriceProductFail(error))
  }
}

function* onUpdateResponsible({ payload: person }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updateResponsibleRegion, person)
    showToast("Changes Successfully Applied")
    yield put(updateRespRegionSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updateRespRegionFail(error))
  }
}

function* onClearFont() {
  try {
    yield put(showLoading(true))
    yield put(clearFontSuccess())
    yield put(hideLoading(false))
  } catch (error) {
    console.log(error)
  }
}

function* onGetFont({ payload: product }) {
  try {
    yield put(showLoading(true))
    const response = yield call(getFont, product)
    yield put(getFontSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(showLoading(true))
    yield put(getFontFail(error.response))
  }
}

function* onGetInfo() {
  try {
    yield put(showLoading(true))
    const response = yield call(getPricesInfo)
    yield put(getInfoDataSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(getInfoDataFail(error))
  }
}

function* onAddInfoData({ payload: data }) {
  try {
    yield put(showLoading(true))
    const response = yield call(addInfoData, data)
    showToast("New Data is added")
    yield put(addInfoDataSuccess(response))
    yield put(hideLoading(false))
    
  } catch (error) {
    yield put(showLoading(true))
    yield put(addInfoDataFail(error.response))
  }
}

function* onUpdateInfoData({ payload: data }) {
  try {
    yield put(showLoading(true))
    const response = yield call(updateInfoData, data)
    showToast("Changes Successfully Applied")
    yield put(updateInfoDataSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(updateInfoDataFail(error))
  }
}

function* onDeleteInfoData({ payload: data }) {
  try {
    yield put(showLoading(true))
    const response = yield call(deleteInfoData, data)
    showToast("Data deleted from the system")
    yield put(deleteInfoDataSuccess(response))
    yield put(hideLoading(false))
  } catch (error) {
    yield put(hideLoading(false))
    yield put(deleteInfoDataFail(error))
  }
}

// function* onGetCatProductsInfo({ payload: data }) {
//   try {
//     yield put(showLoading(true))
//     const response = yield call(getCatProductsInfo, data)
//     yield put(getCatProductsDataSuccess(response))
//     yield put(hideLoading(false))
//   } catch (error) {
//     yield put(showLoading(true))
//     yield put(getCatProductsDataFail(error))
//   }
// }

// function* onGetAccessInfo() {
//   try {
//     yield put(showLoading(true))
//     const response = yield call(getAccessInfo)
//     yield put(getAccessDataSuccess(response))
//     yield put(hideLoading(false))
//   } catch (error) {
//     yield put(hideLoading(false))
//     yield put(getAccessDataFail(error))
//   }
// }

// function* onGetProductsData({ payload: data }) {
//   try {
//     yield put(showLoading(true))
//     const response = yield call(getProductsInfo, data)
//     yield put(getProductsDataSuccess(response))
//     yield put(hideLoading(false))
//   } catch (error) {
//     yield put(showLoading(true))
//     yield put(getProductsDataFail(error))
//   }
// }

// function* onGetRegProductsData({ payload: data }) {
//   try {
//     yield put(showLoading(true))
//     const response = yield call(getRegProductsInfo, data)
//     yield put(getRegProductsDataSuccess(response))
//     yield put(hideLoading(false))
//   } catch (error) {
//     yield put(hideLoading(false))
//     yield put(getRegProductsDataFail(error))
//   }
// }







// function* onGetRegionInfo({ payload: data }) {
//   try {
//     yield put(showLoading(true))
//     const response = yield call(getRegionInfo, data)
//     yield put(getRegionInfoSuccess(response))
//     yield put(hideLoading(false))
//   } catch (error) {
//     yield put(hideLoading(false))
//     yield put(getRegionInfoFail(error))
//   }
// }




// // function* fetchPriceData() {
// //   try {
// //     yield put(showLoading(true))
// //     const response = yield call(getPriceData)
// //     yield put(getPriceDataSuccess(response))
// //     yield put(hideLoading(false))
// //   } catch (error) {
// //     yield put(showLoading(true))
// //     yield put(getPriceDataFail(error))
// //   }
// // }


// function* onAddProductsRegion({ payload: data }) {
//   try {
//     yield put(showLoading(true))
//     yield call(addProductsRegion, data)
//     // yield put(addLostOrderSuccess(response))
//     yield put(hideLoading(false))
//   } catch (error) {
//     yield put(showLoading(true))
//     // yield put(addLostOrderFail(error.response))
//   }
// }


function* pricesSaga() {
  yield takeEvery(GET_PRICES_DATA, onGetPricesInfo)
  yield takeEvery(ADD_PRICE_PRODUCT, onAddPriceProduct)
  yield takeEvery(UPDATE_PRICE_PRODUCT, onUpdatePriceProduct)
  yield takeEvery(DELETE_PRICE_PRODUCT, onDeletePriceProduct)
  yield takeEvery(UPDATE_RESP_REGION, onUpdateResponsible)
  yield takeEvery(CLEAR_FONT, onClearFont)
  yield takeEvery(GET_FONT, onGetFont)

  yield takeEvery(GET_INFO_DATA, onGetInfo)
  yield takeEvery(ADD_INFO_DATA, onAddInfoData)
  yield takeEvery(UPDATE_INFO_DATA, onUpdateInfoData)
  yield takeEvery(DELETE_INFO_DATA, onDeleteInfoData)

  // yield takeEvery(GET_CAT_PRODUCTS_DATA, onGetCatProductsInfo)
  // yield takeEvery(GET_ACCESS_DATA, onGetAccessInfo)
  // yield takeEvery(GET_PRODUCTS_DATA, onGetProductsData)
  // yield takeEvery(GET_REG_PRODUCTS_DATA, onGetRegProductsData)
  // yield takeEvery(UPDATE_RESP_REGION, onUpdateResponsible)
  // yield takeEvery(GET_REGION_INFO, onGetRegionInfo)

  // yield takeEvery(ADD_DATA_REGION, onAddProductsRegion)
}

export default pricesSaga;